/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Edit_DescriptionInputs */

const en_admin_categories_edit_description = /** @type {(inputs: Admin_Categories_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update category details`)
};

const zh_admin_categories_edit_description = /** @type {(inputs: Admin_Categories_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新分类信息`)
};

/**
* | output |
* | --- |
* | "Update category details" |
*
* @param {Admin_Categories_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_edit_description = /** @type {((inputs?: Admin_Categories_Edit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Edit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_edit_description(inputs)
	return zh_admin_categories_edit_description(inputs)
});
export { admin_categories_edit_description as "admin.categories.edit_description" }